import { useSWRConfig } from 'swr';
import { useParams } from 'react-router-dom';
import { useFileUpload } from '@/utils/file/useFileUpload';
import { type CreateEmployeeAttachment } from '@/schemas/API/POST/employee/attachment/request';
import { displayError } from '@/utils/error/errorHandler';

/**
 * Hook that returns function that creates the employee's attachment.
 */
const useCreateEmployeeAttachment = () => {
  const { employeeId } = useParams<{ employeeId: string }>();
  const { mutate } = useSWRConfig();
  const { handleSubmit } = useFileUpload(
    `/employees/${employeeId}/attachments`
  );

  const createEmployeeAttachment = async (
    attachment: CreateEmployeeAttachment
  ) => {
    try {
      await handleSubmit(attachment.file, attachment.name);
      await mutate(`/employees/${employeeId}/attachments`);
    } catch (err) {
      displayError(err);
    }
  };

  return {
    createEmployeeAttachment,
  };
};

export default useCreateEmployeeAttachment;
